import React from "react";
import { FaPlus, FaMinus } from "react-icons/fa6";

const Card = ({ question, answer, isOpen, setIsOpen }) => {
  const { text, bulletPoints } = answer;

  return (
    <div className={`faq ${isOpen ? "bgRed" : "bgWhite"}`}>
      <div className="faq_qu" onClick={() => setIsOpen((isOpen) => !isOpen)}>
        <span>
          {question} {isOpen ? <FaMinus /> : <FaPlus />}
        </span>
        {isOpen && (
          <>
            <div className="faq_ans">
              {" "}
              <p>{text}</p>
              {bulletPoints &&
                bulletPoints.map((list) => <li className="ml-3">{list}</li>)}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Card;
